import {a as a$1}from'./chunk-GTTHVNDA.js';import*as o from'@radix-ui/react-dropdown-menu';import {memo}from'react';import n from'tailwind-styled-components';var p=`
	text-gray-400
	flex
	justify-between
	p-2
	text-black
	cursor-pointer
	rounded-md
	hover:shadow-sm
	hover:bg-gray-100
	focus:outline-none
`,i=`
	focus:outline-none
	disabled:cursor-not-allowed
`,d=`
	bg-white
	rounded-md
	border-gray-300
	border
	p-2
	z-[99]
`;var u=o.Root,s=o.Trigger,g=o.Content,w=o.Item,c=memo(n(w)`
			${({disabled:m})=>a$1(p,m&&"cursor-not-allowed hover:bg-transparent hover:shadow-none")}
			
		`),a=memo(n(s)`
			${()=>a$1(i)}
			
		`),l=memo(n(g)`
			${()=>a$1(d)}
			
		`),t=u;t.Item=c;t.Content=l;t.Trigger=a;var f=t;export{f as a};//# sourceMappingURL=chunk-4RXAANBG.js.map
//# sourceMappingURL=chunk-4RXAANBG.js.map